import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "title mb-0" }
const _hoisted_5 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb mb-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active to-upper"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "text-md-right" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_14 = { class: "shadowed-card bg-white p-3" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-5" }
const _hoisted_17 = { class: "avatar-col" }
const _hoisted_18 = { class: "avatar-img" }
const _hoisted_19 = { class: "change-image-wrapper" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fa fa-camera" }, null, -1)
const _hoisted_21 = { class: "av-desc" }
const _hoisted_22 = {
  key: 0,
  class: "type-holder"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-tie" }, null, -1)
const _hoisted_24 = { class: "mt-0" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "profile-detail-list" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "prof-ico" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope mr-2" })
], -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "prof-ico" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-phone mr-2" })
], -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "to-upper" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "to-upper" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "prof-ico" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-mobile mr-2" })
], -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "to-upper" }
const _hoisted_40 = {
  key: 0,
  class: "green-check-wrap"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_42 = {
  key: 1,
  class: "red-check-wrap"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation" }, null, -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "to-upper" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "prof-ico" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-qrcode mr-2" })
], -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "to-upper" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "to-upper" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "prof-ico" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" })
], -1)
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "col-md-3 text-sm-right" }
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit mr-2" }, null, -1)
const _hoisted_58 = { class: "border rounded p-3 mt-4" }
const _hoisted_59 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "fa fa-building text-muted" }, null, -1)
const _hoisted_63 = { class: "mt-2" }
const _hoisted_64 = /*#__PURE__*/_createVNode("i", { class: "fa fa-map-pin text-muted" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode()
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "mt-2" }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fa fa-phone-alt text-muted" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode()
const _hoisted_70 = { class: "mt-2" }
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope text-muted" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode()
const _hoisted_73 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("i", { class: "fa fa-signature text-muted" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode()
const _hoisted_76 = { class: "signature-wrap mt-2" }
const _hoisted_77 = {
  key: 0,
  class: "shadowed-card bg-white p-3 edit-prof-block"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit mr-2" }, null, -1)
const _hoisted_79 = { class: "form-wrap pt-0" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-md-6" }
const _hoisted_82 = { class: "bg-light p-3 mt-3" }
const _hoisted_83 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-md-4" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = { for: "" }
const _hoisted_88 = { class: "col-md-4" }
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = { for: "" }
const _hoisted_91 = { class: "col-md-4" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = { for: "" }
const _hoisted_94 = { class: "col-md-12" }
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = { for: "" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = { class: "col-md-12" }
const _hoisted_102 = { class: "form-group" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = { class: "col-lg-4" }
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = { for: "country-code-select" }
const _hoisted_107 = { class: "col-lg-8" }
const _hoisted_108 = { for: "contact-number" }
const _hoisted_109 = { class: "col-md-12" }
const _hoisted_110 = { class: "form-group" }
const _hoisted_111 = { class: "row" }
const _hoisted_112 = { class: "col-lg-10" }
const _hoisted_113 = { for: "contact-number" }
const _hoisted_114 = {
  key: 0,
  class: "verified-mobile-icon"
}
const _hoisted_115 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true",
  style: {"color":"green"}
}, null, -1)
const _hoisted_116 = {
  key: 1,
  class: "otp-mini-text",
  style: {"color":"red"}
}
const _hoisted_117 = {
  key: 0,
  class: "col-lg-2"
}
const _hoisted_118 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-lg-5" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = { for: "fname" }
const _hoisted_123 = { class: "col-lg-7 d-flex align-items-center" }
const _hoisted_124 = { class: "form-group otp-counter" }
const _hoisted_125 = { class: "otp-mini-text" }
const _hoisted_126 = { class: "col-md-6" }
const _hoisted_127 = { class: "bg-light p-3 mt-3" }
const _hoisted_128 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_129 = { class: "row" }
const _hoisted_130 = { class: "col-md-12" }
const _hoisted_131 = { class: "form-group" }
const _hoisted_132 = { for: "" }
const _hoisted_133 = { class: "col-md-12" }
const _hoisted_134 = { class: "form-group" }
const _hoisted_135 = { for: "" }
const _hoisted_136 = { class: "col-md-6" }
const _hoisted_137 = { class: "form-group" }
const _hoisted_138 = {
  for: "",
  class: "to-upper"
}
const _hoisted_139 = { class: "col-md-6" }
const _hoisted_140 = { class: "form-group" }
const _hoisted_141 = { for: "" }
const _hoisted_142 = { class: "col-md-6" }
const _hoisted_143 = { class: "form-group" }
const _hoisted_144 = {
  for: "",
  class: "to-upper"
}
const _hoisted_145 = { class: "col-md-6" }
const _hoisted_146 = { class: "form-group" }
const _hoisted_147 = {
  for: "",
  class: "to-upper"
}
const _hoisted_148 = { class: "row" }
const _hoisted_149 = { class: "col-md-12" }
const _hoisted_150 = { class: "bg-light p-3 mt-3" }
const _hoisted_151 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_152 = { class: "row" }
const _hoisted_153 = { class: "col-md-12" }
const _hoisted_154 = { class: "form-group" }
const _hoisted_155 = { for: "" }
const _hoisted_156 = { class: "col-md-12" }
const _hoisted_157 = { class: "form-group" }
const _hoisted_158 = { for: "" }
const _hoisted_159 = { class: "col-md-12" }
const _hoisted_160 = { class: "form-group" }
const _hoisted_161 = { for: "" }
const _hoisted_162 = {
  key: 0,
  class: "signature-wrap mb-2"
}
const _hoisted_163 = { class: "custom-file" }
const _hoisted_164 = { class: "upload-btn-wrapper" }
const _hoisted_165 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_166 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_167 = { class: "col-lg-4" }
const _hoisted_168 = { for: "contact-number" }
const _hoisted_169 = { class: "error-field-text" }
const _hoisted_170 = { class: "col-lg-4" }
const _hoisted_171 = { for: "contact-number" }
const _hoisted_172 = { class: "col-md-12" }
const _hoisted_173 = { class: "bordered-tab-wrap card p-0 my-3" }
const _hoisted_174 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_175 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_176 = {
  class: "nav-link",
  id: "acknowledgement-tab",
  "data-toggle": "tab",
  "data-target": "#acknowledgement",
  type: "button",
  role: "tab",
  "aria-controls": "acknowledgement",
  "aria-selected": "false"
}
const _hoisted_177 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-history" })
], -1)
const _hoisted_178 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_179 = {
  class: "nav-link",
  id: "statement-tab",
  "data-toggle": "tab",
  "data-target": "#statement",
  type: "button",
  role: "tab",
  "aria-controls": "statement",
  "aria-selected": "false"
}
const _hoisted_180 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-statement" })
], -1)
const _hoisted_181 = { class: "tab-content" }
const _hoisted_182 = {
  class: "tab-pane",
  id: "acknowledgement",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_183 = {
  class: "tab-pane",
  id: "statement",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_184 = { class: "row" }
const _hoisted_185 = { class: "col-md-12" }
const _hoisted_186 = { class: "bg-light p-3 mt-3" }
const _hoisted_187 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_188 = { class: "row" }
const _hoisted_189 = { class: "col-md-12" }
const _hoisted_190 = { class: "form-group" }
const _hoisted_191 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_192 = { class: "inline-items" }
const _hoisted_193 = /*#__PURE__*/_createVNode("i", { class: "fa fa-save mr-2" }, null, -1)
const _hoisted_194 = { class: "upload-btn-wrapper" }
const _hoisted_195 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_196 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_197 = { class: "form-group mt-3" }
const _hoisted_198 = {
  key: 0,
  class: "text",
  style: {"color":"red"}
}
const _hoisted_199 = { class: "modal-wrap default-modal" }
const _hoisted_200 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "updateUpload",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_201 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_202 = { class: "modal-content" }
const _hoisted_203 = { class: "modal-header" }
const _hoisted_204 = { class: "d-block" }
const _hoisted_205 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_206 = { class: "text-muted" }
const _hoisted_207 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_208 = { class: "modal-body" }
const _hoisted_209 = { class: "form-wrap pt-0" }
const _hoisted_210 = { class: "avatar-img m-auto" }
const _hoisted_211 = { class: "modal-footer justify-content-center" }
const _hoisted_212 = { class: "upload-btn-wrapper" }
const _hoisted_213 = {
  for: "formFileSm",
  class: "upload-btn btn default-btn"
}
const _hoisted_214 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_country_select = _resolveComponent("country-select")
  const _component_region_select = _resolveComponent("region-select")
  const _component_Editor = _resolveComponent("Editor")
  const _component_router_link = _resolveComponent("router-link")
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('manage_profile')), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("nav", _hoisted_6, [
              _createVNode("ol", _hoisted_7, [
                _hoisted_8,
                _createVNode("li", _hoisted_9, [
                  _createVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('profile')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block me-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectBack && _ctx.redirectBack(...args)))
            }, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              (_ctx.state.data.userdetails.image)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: _ctx.state.data.userdetails.image,
                    alt: "",
                    title: _ctx.state.data.userdetails.email,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showUploadImageModel && _ctx.showUploadImageModel(...args)))
                  }, null, 8, ["src", "title"]))
                : (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
                ,
                    alt: "",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showUploadImageModel && _ctx.showUploadImageModel(...args)))
                  }, null, 8, ["src"])),
              _createVNode("div", _hoisted_19, [
                _createVNode("a", {
                  title: "click to change the image",
                  href: "javascript:void(0)",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showUploadImageModel && _ctx.showUploadImageModel(...args)))
                }, [
                  _hoisted_20
                ])
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              (_ctx.state.data.userdetails && _ctx.state.data.userdetails.user_role
              )
                ? (_openBlock(), _createBlock("span", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.user_role), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("h5", _hoisted_24, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + " :", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.full_name), 1)
              ]),
              (_ctx.state.data.userdetails && _ctx.state.data.userdetails.dob)
                ? (_openBlock(), _createBlock("p", _hoisted_25, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('dob')) + " :", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.dob), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _hoisted_28,
                (_ctx.state.data.userdetails && _ctx.state.data.userdetails.email)
                  ? (_openBlock(), _createBlock("p", _hoisted_29, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + " :", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.email), 1)
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_30, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + " :", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.email), 1)
                    ]))
              ]),
              _createVNode("li", null, [
                _hoisted_31,
                (_ctx.state.data.userdetails &&
                  _ctx.state.data.userdetails.contact_number
                )
                  ? (_openBlock(), _createBlock("p", _hoisted_32, [
                      _createVNode("strong", _hoisted_33, _toDisplayString(_ctx.$t('phone')) + " :", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.contact_number), 1)
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_34, [
                      _createVNode("strong", _hoisted_35, _toDisplayString(_ctx.$t('phone')) + " :", 1),
                      _hoisted_36
                    ]))
              ]),
              _createVNode("li", null, [
                _hoisted_37,
                (_ctx.state.data.userdetails &&
                  _ctx.state.data.userdetails.mobile_number
                )
                  ? (_openBlock(), _createBlock("p", _hoisted_38, [
                      _createVNode("strong", _hoisted_39, _toDisplayString(_ctx.$t('mobile')) + " :", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.mobile_number) + " ", 1),
                      (_ctx.state.data.userdetails.is_mobile_verified)
                        ? (_openBlock(), _createBlock("span", _hoisted_40, [
                            _hoisted_41
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_42, [
                            _hoisted_43
                          ]))
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_44, [
                      _createVNode("strong", _hoisted_45, _toDisplayString(_ctx.$t('mobile')) + " :", 1),
                      _hoisted_46
                    ]))
              ]),
              _createVNode("li", null, [
                _hoisted_47,
                (_ctx.state.data.userdetails && _ctx.state.data.userdetails.zip)
                  ? (_openBlock(), _createBlock("p", _hoisted_48, [
                      _createVNode("strong", _hoisted_49, _toDisplayString(_ctx.$t('zip_code')) + " :", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.zip), 1)
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_50, [
                      _createVNode("strong", _hoisted_51, _toDisplayString(_ctx.$t('zip_code')) + " :", 1),
                      _hoisted_52
                    ]))
              ]),
              (_ctx.state.data.userdetails && _ctx.state.data.userdetails.address_line1
              )
                ? (_openBlock(), _createBlock("li", _hoisted_53, [
                    _hoisted_54,
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('address')) + " :", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.userdetails.address_line1) + ", " + _toDisplayString(_ctx.state.data.userdetails.city) + ", " + _toDisplayString(_ctx.state.data.userdetails.state) + ", " + _toDisplayString(_ctx.state.data.userdetails.country), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.userdetails && _ctx.state.data.userdetails.address_line2
              )
                ? (_openBlock(), _createBlock("li", _hoisted_55))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_56, [
          (!_ctx.state.data.showEditProfile)
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                class: "btn default-btn outline mt-2",
                href: "javascript:void(0)",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showEditProfile && _ctx.showEditProfile(...args)))
              }, [
                _hoisted_57,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit_profile')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_58, [
        _createVNode("h6", null, _toDisplayString(_ctx.$t('company_information')), 1),
        _hoisted_59,
        _createVNode("div", _hoisted_60, [
          _createVNode("div", _hoisted_61, [
            _createVNode("p", null, [
              _createVNode("strong", null, [
                _hoisted_62,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('company_name')) + " :", 1)
              ])
            ]),
            _createVNode("p", null, [
              _createVNode("small", null, _toDisplayString(_ctx.state.data.userdetails.company ? _ctx.state.data.userdetails.company.company_name : ''), 1)
            ]),
            _createVNode("p", _hoisted_63, [
              _hoisted_64,
              _hoisted_65,
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_address')) + " :", 1)
            ]),
            _createVNode("p", null, [
              _createVNode("small", null, _toDisplayString(_ctx.state.data.userdetails.company ? _ctx.state.data.userdetails.company.company_address : ''), 1)
            ])
          ]),
          _createVNode("div", _hoisted_66, [
            _createVNode("p", _hoisted_67, [
              _hoisted_68,
              _hoisted_69,
              _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_number')) + " :", 1)
            ]),
            _createVNode("p", null, [
              _createVNode("small", null, _toDisplayString(_ctx.state.data.userdetails.company ? _ctx.state.data.userdetails.company.company_phone_number : ''), 1)
            ]),
            _createVNode("p", _hoisted_70, [
              _hoisted_71,
              _hoisted_72,
              _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + " :", 1)
            ]),
            _createVNode("p", null, [
              _createVNode("small", null, _toDisplayString(_ctx.state.data.userdetails.company ? _ctx.state.data.userdetails.company.company_email : ''), 1)
            ])
          ]),
          (_ctx.state.data.userdetails.signature)
            ? (_openBlock(), _createBlock("div", _hoisted_73, [
                _createVNode("p", null, [
                  _hoisted_74,
                  _hoisted_75,
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('signature')), 1)
                ]),
                _createVNode("div", _hoisted_76, [
                  _createVNode("img", {
                    alt: "",
                    src: _ctx.state.data.userdetails.signature
                  }, null, 8, ["src"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.state.data.showEditProfile)
      ? (_openBlock(), _createBlock("div", _hoisted_77, [
          _createVNode("h5", null, [
            _hoisted_78,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit_profile')), 1)
          ]),
          _createVNode("div", _hoisted_79, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.data.error.erorList,
              hasError: _ctx.state.data.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _createVNode("div", _hoisted_82, [
                  _createVNode("h6", null, _toDisplayString(_ctx.$t('basic_information')), 1),
                  _hoisted_83,
                  _createVNode("div", _hoisted_84, [
                    _createVNode("div", _hoisted_85, [
                      _createVNode("div", _hoisted_86, [
                        _createVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('first_name')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.editUserDetails.firstName = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.firstName]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_88, [
                      _createVNode("div", _hoisted_89, [
                        _createVNode("label", _hoisted_90, _toDisplayString(_ctx.$t('middle_name')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.editUserDetails.middleName = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.middleName]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_91, [
                      _createVNode("div", _hoisted_92, [
                        _createVNode("label", _hoisted_93, _toDisplayString(_ctx.$t('last_name')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.editUserDetails.lastName = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.lastName]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_94, [
                      _createVNode("div", _hoisted_95, [
                        _createVNode("label", _hoisted_96, _toDisplayString(_ctx.$t('occupation')), 1),
                        _createVNode("div", _hoisted_97, [
                          _createVNode("div", _hoisted_98, [
                            _createVNode(_component_Multiselect, _mergeProps({
                              modelValue: _ctx.state.data.occupation.value,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.occupation.value = $event))
                            }, _ctx.state.data.occupation, {
                              options: _ctx.state.data.occupation.options,
                              onChange: _ctx.checkOther
                            }), null, 16, ["modelValue", "options", "onChange"])
                          ]),
                          (_ctx.state.data.occupation.value === 'Other')
                            ? (_openBlock(), _createBlock("div", _hoisted_99, [
                                _createVNode("div", _hoisted_100, [
                                  _withDirectives(_createVNode("input", {
                                    type: "type",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.editUserDetails.otherOccupation = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.data.editUserDetails.otherOccupation]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_101, [
                      _createVNode("div", _hoisted_102, [
                        _createVNode("div", _hoisted_103, [
                          _createVNode("div", _hoisted_104, [
                            _createVNode("div", _hoisted_105, [
                              _createVNode("label", _hoisted_106, _toDisplayString(_ctx.$t('country_code')), 1),
                              _withDirectives(_createVNode("select", {
                                id: "country-code-select",
                                class: "custom-select form-control",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.phone.code = $event))
                              }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.countryCodeList, (item, itemIndex) => {
                                  return (_openBlock(), _createBlock("option", {
                                    value: item.dial_code,
                                    key: itemIndex
                                  }, _toDisplayString(item.dial_code) + " " + _toDisplayString(item.name), 9, ["value"]))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.state.data.phone.code]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_107, [
                            _createVNode("label", _hoisted_108, _toDisplayString(_ctx.$t('contact_number')), 1),
                            _withDirectives(_createVNode("input", {
                              id: "contact-number",
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.editUserDetails.contactNumber = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.data.editUserDetails.contactNumber]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_109, [
                      _createVNode("div", _hoisted_110, [
                        _createVNode("div", _hoisted_111, [
                          _createVNode("div", _hoisted_112, [
                            _createVNode("label", _hoisted_113, _toDisplayString(_ctx.$t('mobile_number')), 1),
                            _createVNode(_component_AppPhoneNumberInput, {
                              modelValue: _ctx.state.data.editUserDetails.mobileNumber,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.editUserDetails.mobileNumber = $event))
                            }, null, 8, ["modelValue"]),
                            (_ctx.state.data.phone.isVerify)
                              ? (_openBlock(), _createBlock("div", _hoisted_114, [
                                  _hoisted_115
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.ui.mobileNumberRequired &&
                          !_ctx.state.data.editUserDetails.mobileNumber
                        )
                              ? (_openBlock(), _createBlock("p", _hoisted_116, " ! " + _toDisplayString(_ctx.$t('mobile_number_notification')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.state.ui.sendOtpButton && !_ctx.state.data.phone.isVerify
                      )
                            ? (_openBlock(), _createBlock("div", _hoisted_117, [
                                _createVNode("button", {
                                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args))),
                                  disabled: !_ctx.state.data.editUserDetails.mobileNumber,
                                  class: _ctx.state.ui.verifyButton
                          ? 'btn default-btn mt-4'
                          : 'btn default-btn disabled mt-4'
                          
                                }, _toDisplayString(_ctx.$t('verify')), 11, ["disabled"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (_ctx.state.ui.inputOtp)
                      ? (_openBlock(), _createBlock("div", _hoisted_118, [
                          _createVNode("div", _hoisted_119, [
                            _createVNode("div", _hoisted_120, [
                              _createVNode("div", _hoisted_121, [
                                _createVNode("label", _hoisted_122, _toDisplayString(_ctx.$t('otp')), 1),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  id: "otp",
                                  name: "username",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.phone.otp = $event)),
                                  onKeyup: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.checkInputValue && _ctx.checkInputValue(...args))),
                                  number: "",
                                  onPaste: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.state.data.phone.otp]
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_123, [
                              _createVNode("div", _hoisted_124, _toDisplayString(_ctx.state.data.timeCount), 1),
                              _createVNode("p", _hoisted_125, _toDisplayString(_ctx.$t('otp_sent')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_126, [
                _createVNode("div", _hoisted_127, [
                  _createVNode("h6", null, _toDisplayString(_ctx.$t('contact_information')), 1),
                  _hoisted_128,
                  _createVNode("div", _hoisted_129, [
                    _createVNode("div", _hoisted_130, [
                      _createVNode("div", _hoisted_131, [
                        _createVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('address_line_1')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.editUserDetails.addressLine1 = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.addressLine1]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_133, [
                      _createVNode("div", _hoisted_134, [
                        _createVNode("label", _hoisted_135, _toDisplayString(_ctx.$t('address_line_2')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.editUserDetails.addressLine2 = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.addressLine2]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_136, [
                      _createVNode("div", _hoisted_137, [
                        _createVNode("label", _hoisted_138, _toDisplayString(_ctx.$t('country')), 1),
                        _createVNode(_component_country_select, {
                          class: "form-control",
                          modelValue: _ctx.state.data.editUserDetails.country,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.editUserDetails.country = $event)),
                          country: _ctx.state.data.editUserDetails.country,
                          topCountry: "US",
                          whiteList: _ctx.state.data.editUserDetails.whiteList
                        }, null, 8, ["modelValue", "country", "whiteList"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_139, [
                      _createVNode("div", _hoisted_140, [
                        _createVNode("label", _hoisted_141, _toDisplayString(_ctx.$t('zip_code')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.data.editUserDetails.zipCode = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.zipCode]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_142, [
                      _createVNode("div", _hoisted_143, [
                        _createVNode("label", _hoisted_144, _toDisplayString(_ctx.$t('city')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.data.editUserDetails.city = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.city]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_145, [
                      _createVNode("div", _hoisted_146, [
                        _createVNode("label", _hoisted_147, _toDisplayString(_ctx.$t('state')), 1),
                        _createVNode(_component_region_select, {
                          class: "form-control",
                          modelValue: _ctx.state.data.editUserDetails.state,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.data.editUserDetails.state = $event)),
                          country: _ctx.state.data.editUserDetails.country,
                          region: _ctx.state.data.editUserDetails.state
                        }, null, 8, ["modelValue", "country", "region"])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_148, [
              _createVNode("div", _hoisted_149, [
                _createVNode("div", _hoisted_150, [
                  _createVNode("h6", null, _toDisplayString(_ctx.$t('company_information')), 1),
                  _hoisted_151,
                  _createVNode("div", _hoisted_152, [
                    _createVNode("div", _hoisted_153, [
                      _createVNode("div", _hoisted_154, [
                        _createVNode("label", _hoisted_155, _toDisplayString(_ctx.$t('company_name')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.state.data.editUserDetails.companyName = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.companyName]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_156, [
                      _createVNode("div", _hoisted_157, [
                        _createVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('company_address')), 1),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.data.editUserDetails.companyAddress = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.editUserDetails.companyAddress]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_159, [
                      _createVNode("div", _hoisted_160, [
                        _createVNode("label", _hoisted_161, _toDisplayString(_ctx.$t('company_logo')), 1),
                        (_ctx.state.data.editUserDetails.logo)
                          ? (_openBlock(), _createBlock("div", _hoisted_162, [
                              _createVNode("img", {
                                src: _ctx.state.data.editUserDetails.logo.file
                        ? _ctx.state.data.editUserDetails.logo.file
                        : _ctx.state.data.editUserDetails.logo
                        ,
                                alt: ""
                              }, null, 8, ["src"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_163, [
                          _createVNode("div", _hoisted_164, [
                            _createVNode("button", _hoisted_165, [
                              _hoisted_166,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                            ]),
                            _createVNode("input", {
                              type: "file",
                              accept: "image/png, image/jpeg",
                              id: "profileUpdate",
                              onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.uploadLogo($event)))
                            }, null, 32)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_167, [
                      _createVNode("label", _hoisted_168, _toDisplayString(_ctx.$t('email')), 1),
                      _withDirectives(_createVNode("input", {
                        id: "contact-number",
                        type: "email",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.data.editUserDetails.companyEmail = $event)),
                        onKeyup: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.state.data.editUserDetails.companyEmail]
                      ]),
                      _createVNode("p", _hoisted_169, _toDisplayString(_ctx.state.data.error.companyEroor), 1)
                    ]),
                    _createVNode("div", _hoisted_170, [
                      _createVNode("label", _hoisted_171, _toDisplayString(_ctx.$t('phone_number')), 1),
                      _createVNode(_component_AppPhoneNumberInput, {
                        modelValue: _ctx.state.data.editUserDetails.companyPhoneNumber,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.data.editUserDetails.companyPhoneNumber = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_172, [
                      _createVNode("div", _hoisted_173, [
                        _createVNode("ul", _hoisted_174, [
                          _createVNode("li", _hoisted_175, [
                            _createVNode("button", _hoisted_176, [
                              _hoisted_177,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('acknowledgement')), 1)
                            ])
                          ]),
                          _createVNode("li", _hoisted_178, [
                            _createVNode("button", _hoisted_179, [
                              _hoisted_180,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('legal_statement1')), 1)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_181, [
                          _createVNode("div", _hoisted_182, [
                            _createVNode(_component_Editor, {
                              showEnterSetting: false,
                              height: true,
                              onEnterSetting: _ctx.enterSetting,
                              modelValue: _ctx.state.data.editUserDetails.acknowledgement,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.state.data.editUserDetails.acknowledgement = $event))
                            }, null, 8, ["onEnterSetting", "modelValue"])
                          ]),
                          _createVNode("div", _hoisted_183, [
                            _createVNode(_component_Editor, {
                              showEnterSetting: false,
                              height: true,
                              onEnterSetting: _ctx.enterSetting,
                              modelValue: _ctx.state.data.editUserDetails.legalStatement,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.state.data.editUserDetails.legalStatement = $event))
                            }, null, 8, ["onEnterSetting", "modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_184, [
              _createVNode("div", _hoisted_185, [
                _createVNode("div", _hoisted_186, [
                  _createVNode("h6", null, _toDisplayString(_ctx.$t('signature')), 1),
                  _hoisted_187,
                  _createVNode("div", _hoisted_188, [
                    _createVNode("div", _hoisted_189, [
                      _createVNode("div", _hoisted_190, [
                        (_ctx.state.data.signature)
                          ? (_openBlock(), _createBlock("div", _hoisted_191, [
                              _createVNode("img", {
                                src: _ctx.state.data.signature,
                                alt: ""
                              }, null, 8, ["src"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_192, [
                          _createVNode("ul", null, [
                            _createVNode("li", null, [
                              _createVNode("button", {
                                type: "submit",
                                class: "btn default-btn mr-2",
                                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                              }, [
                                _hoisted_193,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                              ])
                            ]),
                            _createVNode("li", null, [
                              _createVNode("div", _hoisted_194, [
                                _createVNode("button", _hoisted_195, [
                                  _hoisted_196,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                                ]),
                                _createVNode("input", {
                                  ref: "signatureInput",
                                  type: "file",
                                  accept: "image/png, image/jpeg",
                                  id: "profileUpdate",
                                  onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                                }, null, 544)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_197, [
              _createVNode("button", {
                type: "submit",
                class: "btn default-btn mr-2",
                onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.saveEditedProfile && _ctx.saveEditedProfile(...args))),
                disabled: _ctx.state.ui.isPostLoading.saveEditedProfile
              }, [
                _createVNode("i", {
                  class: _ctx.state.ui.isPostLoading.saveEditedProfile
              ? 'spinner-border'
              : 'fa fa-save mr-2'
              
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.state.ui.isPostLoading.saveEditedProfile ? _ctx.$t('saving') : _ctx.$t('save')), 1)
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "submit",
                class: "btn default-btn outline danger",
                onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.cancelEditProfile && _ctx.cancelEditProfile(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ]),
            (_ctx.state.data.error.erorList && _ctx.state.data.error.hasError)
              ? (_openBlock(), _createBlock("p", _hoisted_198, _toDisplayString(_ctx.$t('missing_fields')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_199, [
      _createVNode("div", _hoisted_200, [
        _createVNode("div", _hoisted_201, [
          _createVNode("div", _hoisted_202, [
            _createVNode("div", _hoisted_203, [
              _createVNode("div", _hoisted_204, [
                _createVNode("h5", _hoisted_205, _toDisplayString(_ctx.$t('upload_images')), 1),
                _createVNode("p", _hoisted_206, _toDisplayString(_ctx.$t('upload_images')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.hideShowUploadImageModel && _ctx.hideShowUploadImageModel(...args))),
                "aria-label": "Close"
              }, [
                _createVNode(_component_router_link, { to: "/dashboard" }),
                _hoisted_207
              ])
            ]),
            _createVNode("div", _hoisted_208, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.data.error.erorList,
                hasError: _ctx.state.data.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_209, [
                _createVNode("div", _hoisted_210, [
                  _createVNode("img", {
                    src: _ctx.state.data.newUploadImge,
                    alt: "",
                    height: "1500",
                    width: "1500"
                  }, null, 8, ["src"])
                ]),
                (_ctx.state.data.cropImage)
                  ? (_openBlock(), _createBlock(_component_VuePictureCropper, {
                      key: 0,
                      boxStyle: {
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#f8f8f8',
                  margin: 'auto',
                },
                      img: _ctx.state.data.cropImage,
                      options: {
                  viewMode: 1,
                  dragMode: 'crop',
                  aspectRatio: 16 / 16,
                },
                      presetMode: {
                  mode: 'round',
                  width: 100,
                  height: 100,
                }
                    }, null, 8, ["img"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_211, [
              _createVNode("div", _hoisted_212, [
                _createVNode("button", _hoisted_213, [
                  _hoisted_214,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                ]),
                _createVNode("input", {
                  type: "file",
                  multiple: "",
                  accept: "*.*",
                  id: "profileUpdate",
                  onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onDocumentChange($event)))
                }, null, 32)
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.uploadProfileImage && _ctx.uploadProfileImage(...args)))
              }, _toDisplayString(_ctx.$t('save')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 2,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'profile'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 3,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'profile',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ]))
}